module.exports = __webpack_public_path__ + "img/img04.d02e7426.jpg";